import React, { Component } from "react";
import * as Icon from "react-feather";
import moment from "moment";

function formatDate(internalDate) {
	if (!internalDate) return "";
	const m = moment(Number(internalDate));
	const now = moment();
	if (m.isSame(now, "day")) return m.format("h:mm A");
	if (m.isSame(now, "week")) return m.format("ddd");
	if (m.isSame(now, "year")) return m.format("MMM D");
	return m.format("M/D/YY");
}

function extractName(fromHeader) {
	if (!fromHeader) return "(unknown)";
	const m = fromHeader.match(/^\s*"?([^"<]+?)"?\s*<.*>\s*$/);
	if (m) return m[1].trim();
	const justEmail = fromHeader.match(/<(.+?)>/);
	if (justEmail) return justEmail[1];
	return fromHeader.trim();
}

function decodeEntities(s) {
	if (!s) return "";
	return s.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}

class ThreadList extends Component {
	constructor(props) {
		super(props);
		this.state = { searchInput: props.searchQuery || "" };
		this.searchTimer = null;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.searchQuery !== this.props.searchQuery && this.props.searchQuery !== this.state.searchInput) {
			this.setState({ searchInput: this.props.searchQuery || "" });
		}
	}

	onSearchChange = e => {
		const v = e.target.value;
		this.setState({ searchInput: v });
		clearTimeout(this.searchTimer);
		this.searchTimer = setTimeout(() => {
			if (this.props.onSearch) this.props.onSearch(v);
		}, 350);
	};

	onSearchClear = () => {
		this.setState({ searchInput: "" });
		if (this.props.onSearch) this.props.onSearch("");
	};

	onStarClick = (e, thread) => {
		e.stopPropagation();
		if (this.props.onToggleStar) this.props.onToggleStar(thread);
	};

	render() {
		const {
			folder,
			threads,
			selectedThreadId,
			loading,
			refreshing,
			hasMore,
			loadingMore,
			onSelectThread,
			onRefresh,
			onLoadMore,
		} = this.props;
		const { searchInput } = this.state;

		return (
			<div className="thread-list">
				<div className="thread-list__header">
					<div className="thread-list__title">
						<h2>{folder}</h2>
						<button
							className={`thread-list__refresh${refreshing ? " is-spinning" : ""}`}
							onClick={onRefresh}
							title="Refresh"
							disabled={refreshing}
						>
							<Icon.RefreshCw size={16} />
						</button>
					</div>
					<div className="thread-list__search">
						<Icon.Search size={14} className="thread-list__search-icon" />
						<input
							className="thread-list__search-input"
							placeholder="Search mail"
							value={searchInput}
							onChange={this.onSearchChange}
						/>
						{searchInput && (
							<button className="thread-list__search-clear" onClick={this.onSearchClear} title="Clear">
								<Icon.X size={14} />
							</button>
						)}
					</div>
				</div>

				<div className="thread-list__items">
					{loading && threads.length === 0 ? (
						<div className="inbox__empty" style={{ height: "auto", padding: 40 }}>
							<span className="inbox-spinner" />
							<p style={{ marginTop: 14, fontSize: 13 }}>Loading…</p>
						</div>
					) : threads.length === 0 ? (
						<div className="inbox__empty" style={{ height: "auto", padding: 40 }}>
							<Icon.Inbox size={36} />
							<h3>No messages</h3>
							<p>This folder is empty.</p>
						</div>
					) : (
						threads.map(t => {
							const from = decodeEntities(extractName(t.latest && t.latest.from));
							const subject = decodeEntities(t.latest && t.latest.subject) || "(no subject)";
							const snippet = decodeEntities(t.snippet || (t.latest && t.latest.snippet) || "");
							const date = formatDate(t.latest && t.latest.internalDate);
							const classes = ["thread-row"];
							if (t.isUnread) classes.push("is-unread");
							if (selectedThreadId === t.threadId) classes.push("is-selected");
							return (
								<div key={t.threadId} className={classes.join(" ")} onClick={() => onSelectThread && onSelectThread(t.threadId)}>
									<button
										className={`thread-row__star${t.isStarred ? " is-starred" : ""}`}
										onClick={e => this.onStarClick(e, t)}
										title={t.isStarred ? "Unstar" : "Star"}
									>
										<Icon.Star size={14} />
									</button>
									<div className="thread-row__main">
										<div className="thread-row__top">
											<div className="thread-row__from">
												{from}
												{t.messageCount > 1 && <span className="thread-row__count">  ·  {t.messageCount}</span>}
											</div>
											<div className="thread-row__date">{date}</div>
										</div>
										<div className="thread-row__subject">{subject}</div>
										<div className="thread-row__bottom">
											<div className="thread-row__snippet">{snippet}</div>
											{t.hasAttachments && <Icon.Paperclip size={12} className="thread-row__paperclip" />}
										</div>
									</div>
								</div>
							);
						})
					)}
				</div>

				{hasMore && threads.length > 0 && (
					<div className="thread-list__footer">
						<button className="thread-list__more-btn" disabled={loadingMore} onClick={onLoadMore}>
							{loadingMore ? "Loading…" : "Load more"}
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default ThreadList;
